'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct10 from "./scala.-Product10.js";
var $p;
/** @constructor */
function $c_T10(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10) {
  this.mo = null;
  this.mq = null;
  this.mr = null;
  this.ms = null;
  this.mt = null;
  this.mu = null;
  this.mv = null;
  this.mw = null;
  this.mx = null;
  this.mp = null;
  this.mo = _1;
  this.mq = _2;
  this.mr = _3;
  this.ms = _4;
  this.mt = _5;
  this.mu = _6;
  this.mv = _7;
  this.mw = _8;
  this.mx = _9;
  this.mp = _10;
}
export { $c_T10 as $c_T10 };
$p = $c_T10.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T10;
/** @constructor */
function $h_T10() {
}
export { $h_T10 as $h_T10 };
$h_T10.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 10;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct10.$f_s_Product10__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 2104595240, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T10) && ((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mo, x$0.mo) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mq, x$0.mq)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mr, x$0.mr)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ms, x$0.ms)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mt, x$0.mt)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mu, x$0.mu)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mv, x$0.mv)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mw, x$0.mw)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mx, x$0.mx)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.mp, x$0.mp))));
});
$p.o = (function() {
  return "Tuple10";
});
$p.b = (function() {
  return (((((((((((((((((((("(" + this.mo) + ",") + this.mq) + ",") + this.mr) + ",") + this.ms) + ",") + this.mt) + ",") + this.mu) + ",") + this.mv) + ",") + this.mw) + ",") + this.mx) + ",") + this.mp) + ")");
});
function $isArrayOf_T10(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ez)));
}
export { $isArrayOf_T10 as $isArrayOf_T10 };
var $d_T10 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T10, "scala.Tuple10", ({
  ez: 1,
  b: 1,
  c: 1,
  rI: 1,
  a: 1
}));
export { $d_T10 as $d_T10 };
